import React from 'react';
import { useInput } from 'react-admin';
import GradientThemeSelector from './GradientThemeSelector';
import { GradientTheme } from './gradientThemes';

interface GradientThemeFieldProps {
  source: string;
  label?: string;
  onThemeChange?: (theme: GradientTheme) => void;
}

const GradientThemeField: React.FC<GradientThemeFieldProps> = ({
  source,
  label,
  onThemeChange
}) => {
  const {
    field,
  } = useInput({ source });

  const handleChange = (theme: GradientTheme) => {
    field.onChange(theme.id);
    if (onThemeChange) {
      onThemeChange(theme);
    }
  };

  return (
    <GradientThemeSelector
      value={field.value}
      onChange={handleChange}
      label={label}
    />
  );
};

export default GradientThemeField;